import { createFileRoute } from "@tanstack/react-router";

import { PageHero } from "@/components/site/PageHero";
import { SiteFooter } from "@/components/site/SiteFooter";
import { FeatureGridSection, HowItWorksSection } from "@/components/site/sections";
import { FaqSection, faqJsonLd } from "@/components/site/FaqSection";
import { productFaqs } from "@/content/faqs";

export const Route = createFileRoute("/product")({
  head: () => ({
    meta: [
      { title: "Product — adaptED" },
      {
        name: "description",
        content:
          "See how the adaptED product works: check your knowledge, discover your gaps, close them and excel in your exams.",
      },
      { property: "og:title", content: "Product — adaptED" },
      {
        property: "og:description",
        content: "How the adaptED learning companion works, step by step.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://www.adapted.info/product" },
      { property: "og:site_name", content: "adaptED" },
      { name: "twitter:title", content: "Product — adaptED" },
      { name: "twitter:description", content: "How the adaptED learning companion works, step by step." },
      { property: "og:image", content: "https://www.adapted.info/__l5e/assets-v1/a0c65a01-dfc2-43a7-a671-dd73ea78da77/frontier-learning-companion.png" },
      { property: "og:image:alt", content: "Product — adaptED" },
      { name: "twitter:image", content: "https://www.adapted.info/__l5e/assets-v1/a0c65a01-dfc2-43a7-a671-dd73ea78da77/frontier-learning-companion.png" },
    ],
    links: [{ rel: "canonical", href: "https://www.adapted.info/product" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "adaptED learning companion",
          applicationCategory: "EducationalApplication",
          operatingSystem: "Web",
          url: "https://www.adapted.info/product",
          description:
            "A CAPS-native, adaptive AI learning companion that helps South African high school learners check their knowledge, find their gaps and close them.",
          inLanguage: "en-ZA",
          audience: { "@type": "EducationalAudience", educationalRole: "student" },
          publisher: { "@id": "https://www.adapted.info/#organization" },
        }),
      },
      faqJsonLd(productFaqs, "https://www.adapted.info/product"),
    ],
  }),
  component: ProductPage,
});

function ProductPage() {
  return (
    <main id="top">
      <PageHero
        label=""
        title="Product"
        paragraph="adaptED is a CAPS-native learning companion for South African Grade 10–12 learners. It checks what you know, diagnoses knowledge gaps, and guides you through personalised practice so you can walk into every exam with confidence."
      />
      <HowItWorksSection />
      <FeatureGridSection />
      <FaqSection
        items={productFaqs}
        heading="Product questions, answered"
        paragraph="How the learning companion works, what it covers and how it keeps learners safe."
        tone="ink"
      />
      <SiteFooter />
    </main>
  );
}
